<template>
	<div class="nodeExecutionsList">
		<div style="display: flex; gap: 10px; margin-top: 20px; margin-bottom: -5px;">
			<el-select v-model="selectedNodeId" placeholder="All Integrations" clearable filterable style="width: 40%">
				<el-option v-for="node in nodes" :key="node.nodeId" :label="node.nodeName" :value="node.nodeId" />
			</el-select>

			<el-input v-model="searchQuery" placeholder="Search executions..." clearable style="width: 60%"
				@input="onSearchInput" />
		</div>
		<el-date-picker v-model="dateRange" type="daterange" range-separator="To" start-placeholder="Start date"
			end-placeholder="End date" format="dd MMM yyyy" style="width: 100%; margin-top: 20px; margin-bottom: 10px"
			@change="getExecutions" />
		<el-pagination :pager-count="5" :page-sizes="[10, 20, 50]" @current-change="getExecutions"
			@size-change="getExecutions" style="padding-left: 0px; margin-left: -5px; margin-bottom: 10px" background
			:page-size.sync="pageSize" layout="sizes, prev, pager, next" :total="totalRecords"
			:current-page.sync="currentPage">
		</el-pagination>
		<el-tabs v-model="activeFilter" tab-position="top">
			<el-tab-pane :key="filter.name" v-for="filter in filters" :name="filter.name" :label="filter.name">
			</el-tab-pane>
		</el-tabs>
		<el-empty :image="require('../assets/empty.svg')" v-if="!filteredProxyList.length && !loadingList"
			description="No Workflow Executions"></el-empty>
		<workflowExecutionListSkeleton :items="4" :loading="loadingList" />
		<div :key="dateRange.join('-') + activeFilter" v-if="filteredProxyList.length">
			<LazyList defaultLoadingColor="#210f3c" :data="filteredProxyList" :itemsPerRender="15"
				containerClasses="list">
				<template v-slot="{ item }">
					<div @click="executionClicked(item)" :id="item.id"
						:class="'item ' + (activeExectionId === item.id ? 'selected' : '')">
						<div class="innerItemWrapper">
							<div style="z-index: 1; position: absolute; left: 7px; top: 61px">
								<i v-if="item.errorOccurred" style="color: #f56c6c" class="el-icon-error"></i>
								<i v-else style="color: #67c23a" class="el-icon-success"></i>
							</div>
							<div style="margin-left: 10px">
								<el-timeline>
									<el-timeline-item>
										<b>Started: </b>{{ dateToLocalFormat(new Date(item.startTime)) }}
									</el-timeline-item>
									<el-timeline-item style="padding-bottom: 0px">
										<b>Ended: </b>{{ dateToLocalFormat(new Date(item.finishTime)) }}
									</el-timeline-item>
								</el-timeline>
								<p style="font-size: 8px"><b>Ran for: </b>{{ dhm(item.totalRunTimeMs) }}</p>
							</div>
						</div>
					</div>
				</template>
			</LazyList>
		</div>
	</div>
</template>

<script>
import LazyList from "lazy-load-list/vue";
import workflowExecutionListSkeleton from "./workflowExecutionListSkeleton.vue";
import { dateToLocalFormat } from "date-format-ms";
import { mapGetters } from "vuex";
export default {
	components: { LazyList, workflowExecutionListSkeleton },
	computed: {
		filteredProxyList() {
			let filtered = this.executions;
			if (this.activeFilter === "Succesfuly Executed") {
				filtered = this.executions.filter((each) => {
					return !each.errorOccurred;
				});
			} else if (this.activeFilter === "Error Occured") {
				filtered = this.executions.filter((each) => {
					return each.errorOccurred;
				});
			}
			return filtered;
		},
		...mapGetters(["getSelectedWorkflowVersion"]),
	},
	data() {
		return {
			dateRange: [],
			searchQuery: "",
			searchTimer: null,
			executions: [],
			filters: [{ name: "All" }, { name: "Succesfuly Executed" }, { name: "Error Occured" }],
			activeFilter: "All",
			loadingList: false,
			totalRecords: 0,
			currentPage: 1,
			pageSize: 10,
			activeExectionId: null,
			nodes: [],
			selectedNodeId: "",
		};
	},
	beforeMount() {
		const end = new Date();
		const start = new Date();
		start.setDate(end.getDate() - 7);

		this.dateRange = [start, end];
	},
	formatDate(d) {
		return new Date(d).toISOString().split("T")[0];
	},
	async mounted() {
		await this.getNodes();
		await this.getExecutions();
	},
	methods: {
		onSearchInput() {
			clearTimeout(this.searchTimer);
			this.searchTimer = setTimeout(() => {
				this.currentPage = 1;
				this.getExecutions();
			}, 500);
		},
		executionClicked(item) {
			this.activeExectionId = item.id;
			this.$emit("executionClicked", { executionId: item.id, execution: item });
		},
		dhm(ms) {
			const days = Math.floor(ms / (24 * 60 * 60 * 1000));
			const daysms = ms % (24 * 60 * 60 * 1000);
			const hours = Math.floor(daysms / (60 * 60 * 1000));
			const hoursms = ms % (60 * 60 * 1000);
			const minutes = Math.floor(hoursms / (60 * 1000));
			const minutesms = ms % (60 * 1000);
			const sec = Math.floor(minutesms / 1000);
			return days + " Days " + hours + " Hours " + minutes + " Minutes " + sec + " Seconds ";
		},
		dateToLocalFormat(date) {
			return dateToLocalFormat(date, "D jS M Y g:ia");
		},
		getMonday(d) {
			d = new Date(d);
			let day = d.getDay();
			let diff = d.getDate() - day + (day == 0 ? -6 : 1);
			d.setHours(0);
			d.setMinutes(0);
			d.setSeconds(0);
			return d.setDate(diff);
		},
		async getNodes() {
			const workflowId = this.$route.params.workflowId;
			const storedVersion = this.getSelectedWorkflowVersion(workflowId);

			const cleanVersion = storedVersion?.replace(/\?/g, "").trim();

			let url = `logs/listWorkflowNodes?workflowId=${workflowId}`;

			if (cleanVersion) {
				url += `&versionId=${cleanVersion}`;
			}

			const res = await this.httpHelper(
				"RUNTIME",
				"GET",
				url,
				{}
			);

			if (!res?.error) {
				this.nodes = res.response.nodes || [];
			}
		},
		async getExecutions() {
			if (!this.dateRange.length) return;

			this.loadingList = true;
			this.executions = [];

			const [datesAfter, datesBefore] = this.dateRange;
			const workflowId = this.$route.params.workflowId;
			const storedVersion = this.getSelectedWorkflowVersion(workflowId);
			const search = this.searchQuery ? `&search=${this.searchQuery}` : "";
			const node =
				this.searchQuery && this.selectedNodeId
					? `&nodeId=${this.selectedNodeId}`
					: "";

			const result = await this.httpHelper(
				"RUNTIME",
				"GET",
				`logs/returnWorkflowsExecutionSummary?workflowId=${workflowId}&versionId=${storedVersion ?? ""}&datesBefore=${datesBefore}&datesAfter=${datesAfter}&resultsPerPage=${this.pageSize}&page=${this.currentPage - 1}${search}${node}`,
				{}
			);

			setTimeout(() => {
				this.loadingList = false;
				if (!result?.error) {
					this.executions = result.response.executions;
					this.totalRecords = result.response.totalRecords;
				} else {
					this.$notifyError(this, result.error);
				}
			}, 500);
		},
	},
};
</script>

<style scoped>
.nodeExecutionsList {
	width: 399px;
	border-right: 1px solid #e9e9eb;
	height: calc(100vh - 140px);
	position: relative;
	background-color: white;
	position: absolute;
	left: 0;
	bottom: 0px;
	z-index: 1000;
	transition: 0.3s ease all;
	padding-left: 20px;
	padding-right: 20px;
	overflow: hidden;
	cursor: default;
}

.list {
	padding-top: 20px !important;
	max-height: calc(100vh - 312px);
}

.nodeExecutionsList /deep/ .el-tabs__header {
	margin-bottom: 0px !important;
}

.nodeExecutionsList /deep/ .item {
	box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
	border-radius: 4px;
	padding: 10px;
	width: calc(95% - 20px);
	margin-left: 2px;
	cursor: pointer;
	margin-bottom: 10px;
	background-color: white;
	position: relative;
	display: flex;
}

.nodeExecutionsList /deep/ .innerItemWrapper {
	display: inline-flex;
	align-items: top;
	flex: 1;
	position: relative;
}

.selected {
	background-color: #210f3c !important;
	color: white;
}

.selected /deep/ .el-timeline-item__content {
	color: white;
}

.selected /deep/ button {
	color: white;
}

h4 {
	margin: 0px;
}
</style>
